﻿/*==================================================
 *  Localization of labellers.js
 * 
 *  UTF-8 encoded
 *==================================================
 */

Timeline.GregorianDateLabeller.monthNames["ru"] = [
    "Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"
];



//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/ru/labellers.js
// module id = 586
// module chunks = 3